module.exports = __webpack_public_path__ + "static/media/joblist_grey.1cdeb09d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/assets/joblist_grey.svg
// module id = 587
// module chunks = 20